import { render, staticRenderFns } from "./SliderCardPreparation.vue?vue&type=template&id=48b8a774&scoped=true&"
import script from "./SliderCardPreparation.vue?vue&type=script&lang=ts&"
export * from "./SliderCardPreparation.vue?vue&type=script&lang=ts&"
import style0 from "./SliderCardPreparation.vue?vue&type=style&index=0&id=48b8a774&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b8a774",
  null
  
)

export default component.exports